import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        explanations: '=',
        skillName: '='
    },
    template: `
        <div class="modal-header">
            <div class="heading01 heading01b">
                <h2><span ng-if="vm.skillName"> {{ vm.skillName }}</span></h2>
                <ul class="actions01">
                    <li><a class="btn bordered02" ng-click="vm.cancel()">{{ 'general.Close' | translate }}</a></li>
                </ul>
            </div>
        </div>
        <div
            class="modal-body"
            ng-repeat="explanation in vm.explanations"
            ng-if="vm.explanations"
        >
            <h3>{{ explanation.proficiencyPoints }} - {{ explanation.proficiencyName }}</h3>
            <p ng-if="explanation.skillExplanationValue !== ''">{{ explanation.skillExplanationValue }}</p>
            <p ng-if="explanation.skillExplanationValue === ''">
                {{ 'skill.noExplanationAvailable' | translate }}
            </p>
        </div>
    `
})

export default class {
    cancel () {
        this.uibModalInstance.dismiss('cancel');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/skills/proficiency/index.js